import { createContext, useContext } from 'react';

export const SegmentContext = createContext({
    segment: null,
});

export const useSegmentContext = () => useContext(SegmentContext);
